import { createAction, createAsyncAction } from 'utils/actions';

export const FETCH_CART = createAsyncAction('FETCH_CART');
export const ADD_CART = createAsyncAction('ADD_CART');
export const CHANGE_CART = createAsyncAction('CHANGE_CART');
export const DELETE_CART = createAsyncAction('DELETE_CART');
export const RESET_CART = createAction('RESET_CART');
export const ADD_CART_COMMENT = createAction('ADD_CART_COMMENT');